const messages = {
    en: {
      tests: "Tests",
      noRegistrationNeeded: "To use a basic features of our system such as testing, no registration needed.",
      ifYouWouldLike: "If you woul'd like to have an advantage of keeping statistics of your test results or adding your own questions, we'll ask you to register ",
      herre: "here.",
      firstt: "First, please select subject you want to start testing:",
      select: "Select subject",
      currentSubject: "Subject",
      answeredQuestions: "Answered",//"Answered questions"
      question: "Question",
      justClickCorrectAnswer: "Just click correct answer",
      clickToStop: "Click to stop your test",
      allQuestionAreAnswered: "Test is finished",
      correctAnswers: "Correct",
      doneThanks: "Done, thanks",
      myResults: "My all results",
      startYour: "Start your ",
      test: " test",
      currentQuestion: "Current question",
      pleaseConfirmTestStop: "Please confirm test stop",
      stopTesting: "Stop",
      backToTest: "Back to test",
      reportQuestion: "Complain about this question",
      anotherTest: "Another test",
      clickToSelect: "Click To Select subject"
    },
    ru: {
      tests: "Tесты",
      noRegistrationNeeded: "Для использования базовых функций нашей системы, таких как тестирование, регистрация не требуется.",
      ifYouWouldLike: "Если вы хотите вести статистику результатов тестов или добавлять свои собственные вопросы, мы попросим вас зарегистрироваться ",
      herre: "здесь.",
      firstt: "Сначала выберите предмет, по которой хотите начать тестирование:",
      select: "Bыбери предмет",
      currentSubject: "Предмет",
      answeredQuestions: "Отвеченo",//
      question: "Вопрос",
      justClickCorrectAnswer: "Просто нажмите правильный ответ",
      clickToStop: "Нажмите, чтобы остановить тест",
      allQuestionAreAnswered: "Tест закончен c результатoм:",
      correctAnswers: "Правильнo",
      doneThanks: "Готово, спасибо",
      myResults: "Предыдущиe pезультаты",
      startYour: "Начни свой ",
      test: " тест",
      currentQuestion: "Текущий вопрос",
      pleaseConfirmTestStop: "Подтвердите остановку тестa",
      stopTesting: "Стоп",
      backToTest: "Назад к тесту",
      reportQuestion: "Пожаловаться на этот вопрос",
      anotherTest: "Еще один тест",
      clickToSelect: "Нажмите, чтобы выбрать предмет"
    }
  };

  export default messages;